"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkUserOrganizationBrandAccess = void 0;
const UserRoleType_1 = require("../enums/UserRoleType");
const checkUserOrganizationBrandAccess = (user, organizationId, brandId) => {
    var _a;
    if (user.role === UserRoleType_1.UserRoleType.SUPER_ADMIN) {
        return true;
    }
    if (user.role === UserRoleType_1.UserRoleType.ADMIN) {
        return organizationId === user.organizationId;
    }
    if ((_a = user.brandIds) === null || _a === void 0 ? void 0 : _a.length) {
        return user.brandIds.includes(brandId);
    }
    return false;
};
exports.checkUserOrganizationBrandAccess = checkUserOrganizationBrandAccess;
